module.exports = __webpack_public_path__ + "static/media/logoWebl.9a8d23fd.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logoWebl.jpg
 ** module id = 150
 ** module chunks = 0
 **/